import type { ReactElement, VoidFunctionComponent } from 'react';

import { prettyNumber } from '../../../../shared/utils';
import { BadgeColors, BadgeSizes } from '../../generic/Badge/Badge';
import TooltipBadge from '../../generic/Badge/TooltipBadge';

/**
 * Gets badge type for usage
 * @param usage {number} Usage for org
 * @param limit {number} Limit for org
 * @returns {BadgeColors | AlertColors} Alert type to color badge
 */
const getUsageColor = (usage: number, limit: number) => {
  const percentUsage = Math.round((usage / limit) * 100);
  if (percentUsage >= 90) {
    return BadgeColors.WineRed;
  }

  if (percentUsage >= 80) {
    return BadgeColors.DarkYellow;
  }

  return BadgeColors.DarkerGray;
};

type Props = {
  limitUnit: string;
  limit: number;
  usage: number;
  usageTooltip: ReactElement;
  atLimitTooltip?: ReactElement;
};

/**
 * Badge that shows/alerts how many revisions are left for a per revision pricing plan
 */
const UsageBadge: VoidFunctionComponent<Props> = ({ limitUnit, limit, usage, usageTooltip, atLimitTooltip }) => {
  const remaining = Math.max(limit - usage, 0);

  return (
    <TooltipBadge
      id="revision-based-pricing-badge"
      color={getUsageColor(usage, limit)}
      size={BadgeSizes.Small}
      tooltip={remaining ? usageTooltip : atLimitTooltip ?? usageTooltip}
      placement="bottom"
    >
      <b>{prettyNumber(remaining)}</b> of <b>{prettyNumber(limit)}</b> {limitUnit} left
    </TooltipBadge>

  );
};

export default UsageBadge;
